export const BRIDGE_TXN_API_GRAPHQL_URL =
  'https://syn-explorer-api.metagabbar.xyz/graphql'
// 'http://localhost:4000/graphql'
